// Material
import { ListItemText, MenuItem, Skeleton } from '@mui/material'
import { styled } from '@mui/material/styles'

interface StyledMenuItemProps {
  hasError: boolean
}

const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: prop => prop !== 'hasError',
})<StyledMenuItemProps>(({ theme, hasError }) => ({
  padding: '10px 12px',
  color: !hasError ? 'inherit' : theme.palette.error.main,

  ':hover': {
    backgroundColor: theme.palette.secondary.light,
  },
}))

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '.MuiListItemText-primary': {
    ...theme.typography.body2,
    color: 'inherit',
  },
  '&.MuiListItemText-root': {
    flex: '2 2 auto',
    textOverflow: 'ellipsis',
  },
}))

interface Props {
  text: string
  isDisabled?: boolean
  loading?: boolean
  onClick: (() => any) | ((e: Event) => any)
  children: JSX.Element | JSX.Element[]
  error?: boolean
  secondaryChildren?: JSX.Element | JSX.Element[]
}

export function ContextMenuItem({
  text,
  loading = false,
  isDisabled = false,
  children,
  onClick,
  error = false,
  secondaryChildren,
}: Props) {
  return (
    <StyledMenuItem
      disabled={isDisabled || loading}
      onClick={onClick}
      hasError={error}
    >
      {children}
      {loading ? (
        <Skeleton width="80px" sx={{ marginLeft: 'auto' }} animation={false} />
      ) : (
        <StyledListItemText>{text}</StyledListItemText>
      )}
      {secondaryChildren}
    </StyledMenuItem>
  )
}
